import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import { Contacts, MainContact } from '../components'
import contacts from '../contacts'

import './kontakt.css'

const KontaktPage = () => (
  <PageTransition>
    <div className="container">
      <div className="kontakt-main-wrapper">
        <MainContact />
      </div>
      <div className="kontakt-list-wrapper">
        <Contacts contacts={contacts} />
      </div>
    </div>
  </PageTransition>
)

export default KontaktPage



// WEBPACK FOOTER //
// ./src/pages/kontakt.js